<template>
  <span
    v-if="loggedIn && numberOfItemsInShoppingCart"
    class="c-shopping-cart-button__amount"
  >
    {{ numberOfItemsInShoppingCart }}
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('webshop', [
      'numberOfItemsInShoppingCart',
      'shoppingCartExpired'
    ])
  },
  async created() {
    if (this.loggedIn && this.shoppingCartExpired) {
      await this.getShoppingCart();
    }
  },
  methods: {
    ...mapActions('webshop', ['getShoppingCart'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';
  .c-shopping-cart-button__amount {
    position: absolute;
    top: 6px;
    right: 50%;
    background: $label-green;
    height: 18px;
    width: 18px;
    border-radius: 100%;
    font-size: 9px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(120%);

    @include media-breakpoint-up(md) {
      height: 23px;
      width: 23px;
      font-size: 12px;
    }
  }
</style>
